// src/components/common/ProjectNameLink.jsx
import React, { useState } from 'react';
import { useProjectModal } from '../../contexts/ProjectModalContext';

/**
 * Renders a project name as a subtle clickable link.
 * Turns teal + underline on hover.
 *
 * Props:
 *   project  — object with at minimum { project_id }; also accepts { name, client_name }
 *   children — override display text (defaults to project.name or project.project_name)
 *   style    — additional inline styles
 */
const ProjectNameLink = ({ project, children, style = {} }) => {
  const { openProjectModal } = useProjectModal();
  const [hovered, setHovered] = useState(false);

  const isClickable = !!(project?.project_id || project?.name);

  const handleClick = (e) => {
    e.stopPropagation();
    if (isClickable) openProjectModal(project);
  };

  const displayName = children ?? project?.name ?? project?.project_name ?? 'Project';

  if (!isClickable) return <span style={style}>{displayName}</span>;

  return (
    <span
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        cursor: 'pointer',
        color: hovered ? '#03DAC6' : 'inherit',
        textDecoration: hovered ? 'underline' : 'none',
        ...style,
      }}
    >
      {displayName}
    </span>
  );
};

export default ProjectNameLink;
